import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}><path d="M11 11H3v2h8v8h2v-8h8v-2h-8V3h-2v8z" fillRule="evenodd" /></svg>);